module.exports = __webpack_public_path__ + "img/products_7.0beba2d9.png";